const post = {
  slug: 'hello-world',
  published: false,
  title: 'Hello, World!',
  date: '2026-03-30',
  tags: ['general', 'intro'],
  readTime: '2 min read',
  excerpt: 'Welcome to my corner of the internet. This is my first blog post — a quick intro to what I plan to write about.',
  content: `
## Welcome!

Hey there — I'm Anas Qazi, a Software Engineer with over 10 years in the industry.

This blog is where I'll share things I'm learning, building, or thinking about. Expect posts on:

- **Full-stack development** — React, Node.js, cloud architecture
- **Database engineering** — Oracle, PostgreSQL, performance tuning
- **Career & lessons learned** — things I wish I knew earlier

## Why a blog?

Writing forces clarity. If I can't explain something simply, I probably don't understand it well enough. This is as much for me as it is for anyone reading.

## What's next?

I'll be posting regularly about projects I'm working on and topics I find interesting. Stay tuned.

---

Thanks for stopping by. Feel free to [reach out](/contact) if anything resonates.
  `,
};

export default post;
